// import React, { useState } from "react";
// import { NavLink, useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./Login.css"; // Use your existing login styles

// const ForgotPassword = () => {
//   const nav = useNavigate();
//   const [userName, setUserName] = useState("");
//   const [showOtpInput, setShowOtpInput] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [userId, setUserId] = useState("");
//   const [isPasswordVisible, setIsPasswordVisible] = useState(false);
//   const [isOtpVisible, setIsOtpVisible] = useState(false);

//   const togglePasswordVisibility = () => setIsPasswordVisible((prev) => !prev);
//   const toggleOtpVisibility = () => setIsOtpVisible((prev) => !prev);

//   const handleSendOTP = (e) => {
//     e.preventDefault();
//     // API call to send OTP
//     fetch(`${process.env.REACT_APP_BASE_URL}/api/forgotPassword/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ userName }),
//     })
//       .then((res) => {
//         if (res.status === 200) {
//           toast.success("OTP sent to your email");
//           setShowOtpInput(true);
//           res.json().then((data) => setUserId(data.id));
//         } else if (res.status === 400) {
//           toast.error("Unable to send OTP");
//         } else {
//           toast.error("Something went wrong");
//         }
//       })
//       .catch(() => toast.error("Network error"));
//   };

//   const handleReset = (e) => {
//     e.preventDefault();
//     // API call to reset password
//     fetch(`${process.env.REACT_APP_BASE_URL}/api/resetPassword/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ id: userId, otp, password: newPassword }),
//     })
//       .then((res) => {
//         if (res.status === 200) {
//           toast.success("Password changed successfully");
//           nav("/auth");
//         } else if (res.status === 404) {
//           toast.error("Invalid OTP");
//         } else {
//           toast.error("Something went wrong");
//         }
//       })
//       .catch(() => toast.error("Network error"));
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={1000} theme="colored" />
//       <div className="login-bg">
//         <div className="login-container">
//           <div className="login-left">
//             {" "}
//              <img
//               src={require("../../../assests/images/fman1.png")}
//               alt="Logo 1"
//             />
//             <img
//               src={require("../../../assests/images/logo1.png")}
//               alt="Logo 2"
//             />

//           </div>
//           <div className="login-right">
//             {!showOtpInput ? (
//               <>
//                 <h2>Forgot Password</h2>
//                 <form autoComplete="off" onSubmit={handleSendOTP}>
//                   <div className="input-group">
//                     <span className="input-icon">
//                       <i className="fa fa-user" />
//                     </span>
//                     <input
//                       type="text"
//                       placeholder="@username"
//                       value={userName}
//                       onChange={(e) => setUserName(e.target.value)}
//                       required
//                     />
//                   </div>
//                   <button type="submit" className="login-btn">
//                     Send OTP
//                   </button>
//                 </form>
//                 <div className="login-options" style={{ marginTop: "12px" }}>
//                   <NavLink to="/360Login" className="forgot-password">
//                     Back to login
//                   </NavLink>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <h2>Enter OTP & Reset Password</h2>
//                 <form autoComplete="off" onSubmit={handleReset}>
//                   <div className="input-group">
//                     <span className="input-icon">
//                       <i className="fa fa-lock" />
//                     </span>
//                     <input
//                       type={isOtpVisible ? "text" : "password"}
//                       placeholder="OTP"
//                       value={otp}
//                       onChange={(e) => setOtp(e.target.value)}
//                       required
//                     />
//                     <span
//                       className={`password-toggle-icon fa ${
//                         isOtpVisible ? "fa-eye-slash" : "fa-eye"
//                       }`}
//                       onClick={toggleOtpVisibility}
//                     />
//                   </div>
//                   <div className="input-group">
//                     <span className="input-icon">
//                       <i className="fa fa-lock" />
//                     </span>
//                     <input
//                       type={isPasswordVisible ? "text" : "password"}
//                       placeholder="New Password"
//                       value={newPassword}
//                       onChange={(e) => setNewPassword(e.target.value)}
//                       required
//                     />
//                     <span
//                       className={`password-toggle-icon fa ${
//                         isPasswordVisible ? "fa-eye-slash" : "fa-eye"
//                       }`}
//                       onClick={togglePasswordVisibility}
//                     />
//                   </div>
//                   <div className="otp-actions">
//                     <button type="submit" className="login-btn">
//                       Save
//                     </button>
//                     <button
//                       type="button"
//                       className="cancel-btn"
//                       onClick={() => setShowOtpInput(false)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </form>
//               </>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ForgotPassword;
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Login.css";

const ForgotPassword = () => {
  const nav = useNavigate();
  const [userName, setUserName] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [userId, setUserId] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isOtpVisible, setIsOtpVisible] = useState(false);

  // Error states
  const [errors, setErrors] = useState({
    userName: "",
    otp: "",
    newPassword: "",
  });
  const [apiError, setApiError] = useState(""); // <-- new

  const togglePasswordVisibility = () => setIsPasswordVisible((prev) => !prev);
  const toggleOtpVisibility = () => setIsOtpVisible((prev) => !prev);

  const handleSendOTP = (e) => {
    e.preventDefault();

    if (!userName.trim()) {
      setErrors({ ...errors, userName: "User Name is required" });
      return;
    } else {
      setErrors({ ...errors, userName: "" });
    }

    setApiError(""); // clear before request

    fetch(`${process.env.REACT_APP_BASE_URL}/api/forgotPassword/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userName }),
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("OTP sent to your email");
          setShowOtpInput(true);
          res.json().then((data) => setUserId(data.id));
        } else if (res.status === 404) {
          setApiError("User not found"); // show above button
        } else {
          setApiError("Something went wrong");
        }
      })
      .catch(() => setApiError("Network error"));
  };

  const handleReset = (e) => {
    e.preventDefault();

    let tempErrors = { otp: "", newPassword: "" };
    let isValid = true;

    if (!otp.trim()) {
      tempErrors.otp = "OTP is required";
      isValid = false;
    }
    if (!newPassword.trim()) {
      tempErrors.newPassword = "Password is required";
      isValid = false;
    }

    setErrors((prev) => ({ ...prev, ...tempErrors }));
    if (!isValid) return;

    setApiError(""); // clear before request

    fetch(`${process.env.REACT_APP_BASE_URL}/api/resetPassword/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: userId, otp, password: newPassword }),
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success("Password changed successfully");
          nav("/360Login");
        } else if (res.status === 404) {
          setApiError("Invalid OTP");
        } else {
          setApiError("Something went wrong");
        }
      })
      .catch(() => setApiError("Network error"));
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={1000} theme="colored" />
      <div className="login-bg">
        <div className="login-container">
          <div className="login-left">
            <div className="main-logo-container">
              <img
                src={require("../../../assests/images/goldanIcon.png")}
                alt="Main Logo"
                className="main-logo"
              />
            </div>

            <div className="powered-by">
              <p className="power">Powered By</p>
              <img
                src={require("../../../assests/images/logo1.png")}
                alt="Powered By Logo"
                className="powered-logo"
              />
            </div>
          </div>
          <div className="login-right">
            {!showOtpInput ? (
              <>
                <h2>Forgot Password</h2>
                <form autoComplete="off" onSubmit={handleSendOTP}>
                  <div className="input-group mb-2">
                    <span className="input-icon">
                      <i className="fa fa-user" />
                    </span>
                    <input
                      type="text"
                      placeholder="@username"
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  {errors.userName && (
                    <span className="error-msg">{errors.userName}</span>
                  )}

                  {/* API error above button */}
                  {apiError && <div className="log-error">{apiError}</div>}

                  <button type="submit" className="login-btn">
                    Send OTP
                  </button>
                </form>
                <div className="login-options" style={{ marginTop: "12px" }}>
                  <NavLink to="/360Login" className="forgot-password">
                    Back to login
                  </NavLink>
                </div>
              </>
            ) : (
              <>
                <h2>Enter OTP & Reset Password</h2>
                <form autoComplete="off" onSubmit={handleReset}>
                  <div className="input-group mb-2">
                    <span className="input-icon">
                      <i className="fa fa-lock" />
                    </span>
                    <input
                      type={isOtpVisible ? "text" : "password"}
                      placeholder="OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                    <span
                      className={`password-toggle-icon fa ${
                        isOtpVisible ? "fa-eye-slash" : "fa-eye"
                      }`}
                      onClick={toggleOtpVisibility}
                    />
                  </div>
                  {errors.otp && (
                    <span className="error-msg">{errors.otp}</span>
                  )}

                  <div className="input-group mb-2">
                    <span className="input-icon">
                      <i className="fa fa-lock" />
                    </span>
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      placeholder="New Password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <span
                      className={`password-toggle-icon fa ${
                        isPasswordVisible ? "fa-eye-slash" : "fa-eye"
                      }`}
                      onClick={togglePasswordVisibility}
                    />
                  </div>
                  {errors.newPassword && (
                    <span className="log-error">{errors.newPassword}</span>
                  )}

                  {/* API error above buttons */}
                  {apiError && <div className="api-error">{apiError}</div>}

                  <div className="otp-actions">
                    <button type="submit" className="login-btn">
                      Save
                    </button>
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={() => setShowOtpInput(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
